import React from 'react';

import useRuntime from '@belong/providers/runtime/runtime';
import { COLOURS, ICON_SIZES } from '@belong/themes';
import { FlairsValue, IIcon, ITestable } from '@belong/types';

import { Copy } from '../../../styles/Typography';

import { DifferentiatorContainer, DifferentiatorTab, DifferentiatorIcon } from './PlanDifferentiator.styles';

export interface IPlanDifferentiator extends ITestable {
  /**
   * The background colour of the differentiator
   */
  background: FlairsValue;

  /**
   * The text content of the differentiator
   */
  content: string;

  /**
   * The Icon content of the differentiator
   */
  icon?: IIcon;

  /**
   * The id for the header differentiator
   */
  id?: string;
}

export const PlanDifferentiator: React.FC<IPlanDifferentiator> = ({
  icon,
  background,
  content,
  'data-testid': testId,
  id
}) => {
  const { isDesktopViewport } = useRuntime();

  return (
    <DifferentiatorContainer data-testid={testId} tabIndex={-1} aria-hidden="true">
      <DifferentiatorTab
        background={background}
        isDesktopViewport={isDesktopViewport}
        className="plan-card--differentiator-tab"
      >
        {icon && (
          <DifferentiatorIcon
            name={icon.name}
            size={isDesktopViewport ? ICON_SIZES.small : ICON_SIZES.xxsmall}
            className="plan-card--differentiator-tab-icon"
          />
        )}
        <Copy as="span" variant={isDesktopViewport ? 'medium' : 'small'} hasColor={COLOURS.BLACK} isBold id={id}>
          {content}
        </Copy>
      </DifferentiatorTab>
    </DifferentiatorContainer>
  );
};

PlanDifferentiator.displayName = 'PlanDifferentiator';
